import { TimeInput } from '@components/timeInput';
import { FormField } from '@components/ui/form';
import { DatePicker } from '@components/ui/form/date';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { use24h } from '@utils/consts';
import { ExternalScheduleDateInputsProps } from './types';

export const ExternalScheduleDateInputs = ({
  form: { control },
  disabled,
}: ExternalScheduleDateInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });

  return (
    <div className="flex gap-4">
      <FormField
        control={control}
        name="date"
        render={({ field }) => (
          <FormItemWrapper className="w-fit" label={t('date.label')} required>
            <DatePicker
              className="w-[180px]"
              disabled={disabled}
              placeholder={t('default.select.placeholder')}
              {...field}
            />
          </FormItemWrapper>
        )}
      />
      <FormField
        control={control}
        name="time"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItemWrapper className="w-fit" label={t('time.label')} required>
            <TimeInput
              asInput
              id={field.name}
              defaultValue={value ? format(value, use24h ? 'HH:mm' : 'hh:mm a') : undefined}
              disabled={disabled}
              {...field}
              onInputChange={onChange}
            />
          </FormItemWrapper>
        )}
      />
    </div>
  );
};
